export class MessageBag {
    _messages = {};

    constructor(messages = null) {
        if (messages != null) this._messages = messages;
    }

    add(key, message) {
        this._messages[key] = message;
    }

    get(key) {
        return this._messages[key]
    }

    getAll() {
        return Object.values(this._messages);
    }

    getRaw() {
        return this._messages;
    }

    delete(key) {
        delete this._messages[key]
    }

    empty() {
        this._messages = {};
    }

    isEmpty() {
        return Object.keys(this._messages).length === 0;
    }

    has(key) {
        return this._messages[key] != null;
    }
}
